import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	list: {
		width: "95%",
		margin: "0 auto"
	},
	listItem: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		borderRadius: "6px",
		boxShadow: "3px 3px 16px rgba(0, 0, 0, 0.06)"
	},
	listItemText: {
		fontWeight: "normal"
	},
	nextIcon: {
		color: colors.gray[500],
		minWidth: "0px"
	},
	nextIconDisabled: {
		opacity: "0.4"
	},
	drawerHeader: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		height: 56
	},
	closeButton: {
		position: "absolute",
		left: theme.spacing(1)
	}
}))

export default useStyles
